import { Guid } from "./Guid";
import { TimeSpan } from "./TimeSpan";
import { ObjUtils } from "./ObjUtils";
import { MacAddress } from "../Core/MacAddress";
import { IpAddress } from "../Core/IpAddress";
import { IpSubnet } from "../Core/IpSubnet";
import { IpRange } from "../Core/IpRange";
import { IpOctetRange } from "../Core/IpOctetRange";

export class ValueEncoder {

	// Integer

	public static EncodeInteger(value: number): string {
		return value.toString();
	}

	public static DecodeInteger(s: string): number {
		return parseInt(s);
	}

	// Double

	public static EncodeDouble(value: number): string {
		return value.toString();
	}

	public static DecodeDouble(s: string): number {
		return parseFloat(s);
	}

	// Boolean

	public static EncodeBoolean(value: boolean): string {
		return (value ? "true" : "false");
	}

	public static DecodeBoolean(s: string): boolean {
		s = s.toLowerCase();
		return ((s === "true") || (s === "t"));
	}

	// Date

	public static EncodeDateTime(value: Date): string {
		// The Date class methods seem to behave under the assumption
		// that the Date represents a "local" time.  For example,
		// the toISOString method automatically converts the time to UTC
		// before constructing the string.  (Thus, no need to convert
		// the time to UTC yourself.)

		return value.toISOString();
	}

	public static DecodeDateTime(s: string): Date {
		// The Date class methods seem to behave under the assumption
		// that the Date represents a "local" time.  For example,
		// the parse method automatically converts the time to "local"
		// before returning its result.  (Thus, no need to convert
		// the time to "local" yourself.)

		return new Date(Date.parse(s));
	}

	// TimeSpan

	public static EncodeTimeSpan(value: TimeSpan): string {
		return value.ToString();
	}

	public static DecodeTimeSpan(s: string): TimeSpan {
		return TimeSpan.Create(s);
	}

	// IpAddress

	public static EncodeIpAddress(value: IpAddress): string {
		return value.ToString();
	}

	public static DecodeIpAddress(s: string): IpAddress {
		return IpAddress.Create(s);
	}

	// MacAddress

	public static EncodeMacAddress(value: MacAddress): string
	{
		return value.ToString();
	}

	public static DecodeMacAddress(s: string): MacAddress {
		return MacAddress.CreateFromString(s);
	}

	// IpRange

	public static EncodeIpRange(value: IpRange): string	{
		return value.ToString();
	}

	public static DecodeIpRange(s: string): IpRange	{
		return IpRange.CreateFromString(s);
	}

	// IpOctetRange

	public static EncodeIpOctetRange(value: IpOctetRange): string {
		return value.ToString();
	}

	public static DecodeIpOctetRange(s: string): IpOctetRange {
		return IpOctetRange.Create(s);
	}

	// IpSubnet

	public static EncodeIpSubnet(value: IpSubnet): string {
		return value.ToString();
	}

	public static DecodeIpSubnet(s: string): IpSubnet {
		return IpSubnet.CreateFromString(s);
	}

	// Guid

	public static EncodeGuid(value: Guid): string {
		return value.ToString();
	}

	public static DecodeGuid(s: string): Guid {
		if (!s)
			return Guid.Empty;
		else
			return Guid.FromString(s);
	}

}
